import noUiSlider from 'nouislider';
import { triggerEvent } from '../../services/helpers/trigger-event';

function formatValue(value) {
    value = value | 0;

    if (value >= 1000) {
        return parseInt(value / 1000) + 'K';
    }
    else {
        return value;
    }
}

function createTooltip(parent) {
    const tooltip = document.createElement("div");
    const span = document.createElement("span");

    tooltip.classList.add("handle-tooltip");
    tooltip.appendChild(span);
    parent.appendChild(tooltip);

    return tooltip;
}

function init(range, config = {}) {
    const valueFormatter = config.transformValue || (i => parseInt(i));
    const tooltipFormatter = config.format || formatValue;
    const targetSelectors = range.dataset.slider;
    const min = range.dataset.sliderMin || 0;
    const max = range.dataset.sliderMax || 100;
    const step = range.dataset.sliderStep || 50;
    const margin = range.dataset.sliderMargin || 0;
    const value = range.dataset.sliderValue || min;
    let targets = [];

    if (targetSelectors) {
        targets = targetSelectors
            .split(",")
            .map(selector => document.querySelector(selector))
            .filter(element => element);
    }

    noUiSlider.create(range, {
        start: [ value ],
        connect: "lower",
        margin: +margin,
        range: { min: +min, max: +max },
        step: +step
    });

    const lower = range.querySelector(".noUi-handle-lower");
    const lowerTooltip = createTooltip(lower);
    const lowerSpan = lowerTooltip.querySelector("span");

    if (targets.length) {
        range.noUiSlider.on("update", () => {
            const lower = range.noUiSlider.get();

            lowerSpan.textContent = tooltipFormatter(lower);
        });

        range.noUiSlider.on("set", () => {
            const value = range.noUiSlider.get();

            for (let i = 0; i < targets.length; ++i) {
                targets[i].value = valueFormatter(value);
                triggerEvent(targets[i], "change");
            }
        });
    }

    return {
        onUpdate(handler) {
            range.noUiSlider.on("update", () => handler(range.noUiSlider.get()));
        },
        onChange(handler) {
            range.noUiSlider.on("change", () => handler(range.noUiSlider.get()));
        }
    };
}

export { init };
